var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 47C36.4787 47 47 36.4787 47 23.5C47 10.5213 36.4787 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62601 34.86H33.371V20.126H7.62601V34.862V34.86ZM9.99501 24.273C10.5433 24.2727 11.069 24.0547 11.4567 23.667C11.8443 23.2792 12.062 22.7533 12.062 22.205H28.935C28.935 22.7535 29.1529 23.2795 29.5407 23.6673C29.9285 24.0551 30.4545 24.273 31.003 24.273V30.707C30.4545 30.707 29.9285 30.9249 29.5407 31.3127C29.1529 31.7005 28.935 32.2265 28.935 32.775H12.062C12.0623 32.5034 12.009 32.2345 11.9052 31.9835C11.8015 31.7326 11.6492 31.5045 11.4572 31.3125C11.2653 31.1204 11.0373 30.9681 10.7864 30.8642C10.5355 30.7603 10.2666 30.7069 9.99501 30.707V24.273Z",
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.498 30.595C21.3207 30.595 22.1097 30.2682 22.6914 29.6865C23.2732 29.1047 23.6 28.3157 23.6 27.493C23.6 26.6703 23.2732 25.8813 22.6914 25.2996C22.1097 24.7178 21.3207 24.391 20.498 24.391C19.6753 24.391 18.8863 24.7178 18.3046 25.2996C17.7228 25.8813 17.396 26.6703 17.396 27.493C17.396 28.3157 17.7228 29.1047 18.3046 29.6865C18.8863 30.2682 19.6753 30.595 20.498 30.595Z",
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.979 19.093H34.404V30.987L36.481 30.767L34.941 16.117L8.979 19.093Z",
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.474 12.15L10.374 17.659L35.855 14.982L37.134 27.137L39.251 26.628L36.474 12.15Z",
    fill: "#F59E0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.516c0f881891cf477193448eb5e37c0b.svg";
export { ForwardRef as ReactComponent };